import { render, staticRenderFns } from "./TrangXemVaiTro.vue?vue&type=template&id=b9a88100&"
import script from "./TrangXemVaiTro.vue?vue&type=script&lang=js&"
export * from "./TrangXemVaiTro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports